import React from "react";

function SocialMediaShareBtn() {
  return <div className="social-media-pop-btn">Share</div>;
}

export default SocialMediaShareBtn;
